import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
const base = 'orders'

AdminRouter.addRoute({
  name: `company-orders`,
  path: `/company-orders`,
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
  permission: $vm => {
    return $vm.$account && $vm.$account.company
  },
})

AdminRouter.addRoute({
  name: `company-orders-pay`,
  path: `/company-orders/:id/pay`,
  component: () => import('../../../personal/src/orders/Pay.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}`,
  order: 40,
  header: $vm => $vm.$t(`general.menu_main`),
  text($vm) {
    return $vm.$t(`${base}.title`)
  },
  route: {
    name: `company-orders`,
  },
  icon: 'icon-coins',
  permission: $vm => {
    return !$vm.$allows('administer')
  },
})
